import React, { useEffect, useContext, useState } from 'react';
import { A } from 'hookrouter';
import { courseCategoryOptions, courseLanguageOptions, translateOptionValue } from '../exl/shared/translations';
import { HandleRemoveCertificate } from '../exl/requests/CertificateRequests';
import { DataContext as SharedDataContext } from '../../stores/crm-store';
import { DataContext as ExlDataContext } from '../../stores/exl-store';
import { getIcon } from '../crm/shared/field_inputs/shared/FormatHelpers';
import { DataContext as CovDataStore } from '../../store';
import { useTranslation } from 'react-i18next';
import { COURSE_TABLE_NAME_COL, COURSE_CERTIFICATION_TYPE_LABEL, COURSE_CERTIFICATION_TAGS_LABEL, GENERAL_COURSE_INFO_CATEGORY_LABEL, GENERAL_COURSE_INFO_LANGUAGE_LABEL, COURSE_TABLE_START_DATE_COL, COURSE_TABLE_END_DATE_COL, COURSE_TABLE_NO_START_DATE, COURSE_TABLE_NO_END_DATE, EMPLOYEE_DETAILS_NO_CERTIFICATES_INFO, INDEPENDENT_CERTIFICATION_LABEL, INDEPENDENT_CERTIFICATION_DESC, DELETE, CERTIFICATE_MODALS_DELETE_CERTIFICATE_WARN } from '../../i18n/keyConstants';
import moment from 'moment';
import { Button } from 'react-bootstrap'
import Loading from '../Loading';
import OnHoverTooltip from '../tables/shared/OnHoverTooltip';
import BookingStatusDisplay from './BookingStatusDisplay';
import AddCertificate from '../exl/AddCertificate';
import EditCertificate from '../exl/EditCertificate';
import CustomModal from '../tables/shared/CustomModal';

import axios from 'axios';
const CancelToken = axios.CancelToken;
let cancel;

const getCourse = (certificate) => {
    if (certificate.exlBooking !== null) {
        return certificate.exlBooking?.course;
    }
    return null;
}

const CertificateActions = ({
    certificate,
    editCertificateModalOpen,
    setEditCertificateModalOpen,
    deleteCertificateModalOpen,
    setDeleteCertificateModalOpen,
    handleRemove,
    isRemoving,
    sharedDispatch,
    t,
    selected,
    setSelected
}) => {
    return (
        <>
            <Button variant="info" onClick={() => { setEditCertificateModalOpen(true); setSelected(certificate.id); console.log(certificate.id) }} className="exl-button admin-btn-edit">{getIcon('edit')}</Button>
            <Button variant="info" onClick={() => { setDeleteCertificateModalOpen(true); setSelected(certificate.id); console.log(certificate.id) }} className="exl-button btn-danger admin-btn-delete">{getIcon('delete')}</Button>

            <EditCertificate
                certificate={certificate}
                open={editCertificateModalOpen && selected === certificate.id}
                onClose={() => setEditCertificateModalOpen(false)}
            />
            <CustomModal
                show={deleteCertificateModalOpen && selected === certificate.id}
                onHide={() => { setDeleteCertificateModalOpen(false) }}
                modalText={t(CERTIFICATE_MODALS_DELETE_CERTIFICATE_WARN)}
                buttonText={t(DELETE, { ns: 'shared' })}
                handleModal={() => { handleRemove(certificate.id, sharedDispatch) }}
                modalVariant='danger'
                isSaving={isRemoving}
                buttonClassName="btn btn-danger"
            />
        </>
    )
}

const EmpCertificateInfo = ({ certifications, id, isLoading, canManageCertificates }) => {
    const { dispatch: sharedDispatch } = useContext(SharedDataContext);
    const { store: covStore } = useContext(CovDataStore);
    const { store: exlStore, dispatch: exlDispatch } = useContext(ExlDataContext);
    const user = covStore?.user;

    id = decodeURIComponent(id);
    const { t } = useTranslation(['certificateModals']);

    const [deleteCertificateModalOpen, setDeleteCertificateModalOpen] = useState(false);
    const [editCertificateModalOpen, setEditCertificateModalOpen] = useState(false);
    const [selectedCertificateId, setSelectedCertificateId] = useState();
    const [isRemoving, setIsRemoving] = useState();

    const handleRemove = async (certificateId, sharedDispatch) => {
        setIsRemoving(true);
        var response = await HandleRemoveCertificate(certificateId, sharedDispatch);
        if (response.success) {
            sharedDispatch({ type: 'SHOW_DELETED_TOAST' });
        }
        else {
            sharedDispatch({ type: 'SHOW_ERROR_TOAST' });
        }
        setIsRemoving(false);
        window.location.reload();
    }

    useEffect(() => {
        async function fetchData() {
            cancel && cancel();
            const uri = `api/exlcertificatefront/tags`;

            // push to url if its not initial or changed

            const params = {};
            //if (JSON.stringify(params) !== JSON.stringify(initialParams) || hasChanged) {
            //    const queryString = qs.stringify(params);
            //    const url = `${window.location.pathname}?${queryString}`;
            //    window.history.pushState(null, '', url);
            //} else {
            //    setHasChanged(true);
            //    console.log('initial start');
            //}

            //const newRequestUri = uri + '/' + JSON.stringify(params);

            //if (newRequestUri === requestUri && mainStore.store.loadedTabs['/coverings']) {
            //    return;
            //}
            exlDispatch({ type: 'SET_ISLOADING_TRUE' });
            //exlDispatch({ type: 'SET_REQUEST_URI', payload: newRequestUri });

            try {
                axios
                    .get(uri, {
                        params: params,
                        cancelToken: new CancelToken((c) => {
                            cancel = c;
                        }),
                        headers: {
                            Accept: 'application/json, text/plain, */*',
                            'Content-Type': 'application/json;charset=UTF-8',
                        },
                    })
                    .then((response) => {
                        console.log('resp', response.data);

                        exlDispatch({
                            type: 'FETCH_CERTIFICATE_TAGS',
                            certificateTags: response.data,
                        });
                    })
                    .catch((thrown) => {
                        if (axios.isCancel(thrown)) {
                            //TODO Something when request is cancelled?
                        } else {
                            const error = thrown.response;
                            exlDispatch({ type: 'FETCH_ERROR', payload: error });
                        }
                    });
            } catch (error) {
                console.error(error);
                exlDispatch({ type: 'SET_ISLOADING_FALSE' });
            }
        }
        fetchData();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            {isLoading ? <Loading></Loading> :
                <section>

                    <div className='container margin-top-15px'>
                        {user.isExlCertificateAdmin || canManageCertificates ? (

                            <AddCertificate id={id.toUpperCase()} />
                        ): <></>
                        }
                        {certifications && certifications.length ? (
                            <>
                                <div className='d-flex justify-content-between employee-certificates col-12 padding-none'>
                                    <table className='table table-striped table-sm font'>
                                        <thead>
                                            <tr>
                                                <th className='padding-left-10px'>{t(COURSE_TABLE_NAME_COL, { ns: 'courseTable' })}</th>
                                                <th className='text-center'>{t(COURSE_CERTIFICATION_TYPE_LABEL, { ns: 'courseBookings' })}</th>
                                                <th className='text-left'>{t(COURSE_CERTIFICATION_TAGS_LABEL, { ns: 'courseBookings' })}</th>
                                                <th className='text-center'>{t(GENERAL_COURSE_INFO_LANGUAGE_LABEL, { ns: 'generalCourseInformation' })}</th>
                                                <th className='text-right padding-left-10px'>{t(COURSE_TABLE_START_DATE_COL, { ns: 'courseTable' })}</th>
                                                <th className='text-right padding-right-10px'>{t(COURSE_TABLE_END_DATE_COL, { ns: 'courseTable' })}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {certifications.map((certificate, index) => (
                                                <tr key={index} >
                                                    {getCourse(certificate) ?
                                                        <>
                                                            <td className='padding-left-10px month'>
                                                                <A href={`/exlCourseDetails/${getCourse(certificate).id}`}>{getCourse(certificate).name}</A>
                                                            </td>
                                                            <td className='text-center'>
                                                                <BookingStatusDisplay booking={certificate.exlBooking} />
                                                            </td>
                                                            <td className='text-left'>-</td>
                                                            <td className='text-center'>
                                                                {t(translateOptionValue(getCourse(certificate).language, courseLanguageOptions), { ns: 'shared' })}
                                                            </td>
                                                            <td className='text-right intern-hours'>{moment.utc(getCourse(certificate).startDate).local().isValid() ? moment.utc(getCourse(certificate).startDate).local().format('YYYY-MM-DD') : t(COURSE_TABLE_NO_START_DATE, { ns: 'courseTable' })}</td>
                                                            <td className='text-right intern-hours padding-right-10px'>{moment.utc(getCourse(certificate).endDate).local().isValid() ? moment.utc(getCourse(certificate).endDate).local().format('YYYY-MM-DD') : t(COURSE_TABLE_NO_END_DATE, { ns: 'courseTable' })}</td>
                                                        </>
                                                        :
                                                        <>
                                                            <td className='padding-left-10px month'>{certificate.name}</td>
                                                            <td className='text-center'>
                                                                {t(INDEPENDENT_CERTIFICATION_LABEL, { ns: 'shared' })}
                                                                <OnHoverTooltip
                                                                    dataFor='course-status'
                                                                    tooltipPlace='right'
                                                                    tooltipEffect='solid'
                                                                >
                                                                    <span className='oi oi-info c-steelblue padding-left-10px' style={{ fontSize: "10px" }} />
                                                                    {t(INDEPENDENT_CERTIFICATION_DESC, { ns: 'shared' })}
                                                                </OnHoverTooltip>

                                                            </td>
                                                            <td className='text-left'>{certificate.tags && certificate.tags.length ? certificate.tags.map(c => c.name).join(', ') : ''}</td>
                                                            <td className='text-center'>-</td>
                                                            <td className='text-right intern-hours'>-</td>
                                                            <td className='text-right intern-hours padding-right-10px'>{moment.utc(certificate.certificateDate).local().isValid() ? moment.utc(certificate.certificateDate).local().format('YYYY-MM-DD') : t(COURSE_TABLE_NO_END_DATE, { ns: 'courseTable' })}</td>
                                                            {user.isExlCertificateAdmin || canManageCertificates ? (
                                                                <td className='admin-btn-row'>
                                                                    <CertificateActions
                                                                        certificate={certificate}
                                                                        deleteCertificateModalOpen={deleteCertificateModalOpen}
                                                                        setDeleteCertificateModalOpen={setDeleteCertificateModalOpen}
                                                                        editCertificateModalOpen={editCertificateModalOpen}
                                                                        setEditCertificateModalOpen={setEditCertificateModalOpen}
                                                                        handleRemove={handleRemove}
                                                                        isRemoving={isRemoving}
                                                                        sharedDispatch={sharedDispatch}
                                                                        t={t}
                                                                        selected={selectedCertificateId}
                                                                        setSelected={setSelectedCertificateId}
                                                                    />
                                                                </td>
                                                            ) : <></>
                                                            }
                                                        </>
                                                    }

                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </>
                        ) : (
                            <>
                                <div className='container'>
                                    <div className='col-10 offset-1 col-md-6 offset-md-3 col-lg-4 offset-lg-4 padding-top-30px'>
                                        <p className='text-center'>{t(EMPLOYEE_DETAILS_NO_CERTIFICATES_INFO, { ns: 'employeeDetails' })}</p>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </section>
            }

        </>
    );
};

export default EmpCertificateInfo;